import _defineProperty from "/home/runner/work/jfssvex.github.io/jfssvex.github.io/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import { css, pseudoSelectors } from "@chakra-ui/styled-system";
import { get, isNumber, isString, __DEV__, merge, omit } from "@chakra-ui/utils";
/**
 * Carefully selected html elements for chakra components.
 * This is mostly for `chakra.<element>` syntax.
 */

export var domElements = ["a", "article", "aside", "blockquote", "button", "caption", "cite", "circle", "code", "dd", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hr", "img", "input", "kbd", "label", "li", "mark", "nav", "ol", "p", "path", "pre", "q", "rect", "s", "svg", "section", "select", "small", "span", "sub", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "tr", "ul"];
export var cast = function cast(arg) {
  return arg;
};
export function omitThemingProps(props) {
  return omit(props, ["styleConfig", "size", "variant", "colorScheme"]);
}
export function pseudoProps(_ref) {
  var theme = _ref.theme,
      props = _objectWithoutPropertiesLoose(_ref, ["theme"]);

  var result = {};

  for (var prop in props) {
    if (prop in pseudoSelectors) {
      var style = css(_defineProperty({}, prop, props[prop]))(theme);
      result = _extends({}, result, style);
    }
  }

  return result;
}
export function truncateProp(_ref2) {
  var isTruncated = _ref2.isTruncated,
      noOfLines = _ref2.noOfLines;

  if (isNumber(noOfLines)) {
    return {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: noOfLines
    };
  }

  if (isTruncated) {
    return {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    };
  }
}
export var extraProps = function extraProps(props) {
  var layerStyle = props.layerStyle,
      textStyle = props.textStyle,
      apply = props.apply,
      theme = props.theme;
  var styles = merge({}, get(theme, "layerStyles." + layerStyle, {}), get(theme, "textStyles." + textStyle, {}));
  return css(_extends({}, styles, {
    apply: apply
  }))(theme);
};
export default function isTag(target) {
  return isString(target) && (__DEV__ ? target.charAt(0) === target.charAt(0).toLowerCase() : true);
}
export function getDisplayName(primitive) {
  return isTag(primitive) ? "chakra." + primitive : getComponentName(primitive);
}

function getComponentName(primitive) {
  return (__DEV__ ? isString(primitive) && primitive : false) || !isString(primitive) && primitive.displayName || !isString(primitive) && primitive.name || "ChakraComponent";
}